"use client"
import {
  NativeSelect
} from "./chunk-A7LXFFQU.mjs";
import {
  Menu
} from "./chunk-ULYETFJE.mjs";

// src/components/select.ts
import { mergeMultiStyle } from "@yamada-ui/core";
var Select = mergeMultiStyle(
  NativeSelect,
  Menu,
  {
    baseStyle: {
      content: {
        w: "100%"
      },
      footer: {},
      header: {},
      inner: {},
      item: {
        _active: {
          bg: ["blackAlpha.200", "whiteAlpha.200"]
        },
        _hover: {
          bg: ["blackAlpha.100", "whiteAlpha.100"],
          _disabled: {
            bg: ["white", "black"]
          },
          _focus: {
            bg: ["blackAlpha.50", "whiteAlpha.50"]
          }
        }
      },
      itemIcon: {},
      list: {
        maxH: "xs",
        overflowY: "auto"
      }
    }
  }
)({ omit: ["button", "command"] });

export {
  Select
};
//# sourceMappingURL=chunk-RFLHYWNR.mjs.map